module.exports = __webpack_public_path__ + "static/media/iosevka-ss08-regular.b44daa8a.woff";